<template>
  <div class="news_wrap">
    <div class="news">
      <page-header class="not_main"></page-header>
      <div class="news_content">

        <image-component :infoType="'newsBanner'"></image-component>


        <board-list-component :boardType="`news`"></board-list-component>

      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>

import ImageComponent from "@/components/information/ImageComponent";
import BoardListComponent from "@/components/board/BoardListComponent";
export default {
name: "News",
  mixins: [],
  components: {BoardListComponent, ImageComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>